const MenuItemBullet = () => (
  <span className="menu-bullet">
    <span className="bullet bullet-dot" />
  </span>
)

export default MenuItemBullet
